"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class TimeslotApi {
    constructor(api) {
        this.api = api;
    }
    getDates(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/timeslot/date';
            const response = yield this.api.axiosNode.get(endpoint, { params });
            return response.data;
        });
    }
    getTimes(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = 'c/timeslot/time';
            const response = yield this.api.axiosNode.get(endpoint, { params });
            return response.data;
        });
    }
    getSpecialDates(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/timeslot/special/date';
            const response = yield this.api.axiosNode.get(endpoint, { params });
            return response.data;
        });
    }
    getSpecialTimes(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/timeslot/special/date';
            const response = yield this.api.axiosNode.get(endpoint, { params });
            return response.data;
        });
    }
    checkAvailable(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/timeslot/available';
            const response = yield this.api.axiosNode.get(endpoint, { params });
            return response.data;
        });
    }
}
exports.default = TimeslotApi;
//# sourceMappingURL=Timeslot.js.map